"use client";

import { useCallback } from "react";

type TFormApiWithDefaultValueState = {
  state: {
    isDefaultValue: boolean;
  };
};

type TFormChangeListenerProps = {
  formApi: TFormApiWithDefaultValueState;
};

export type TUseFormsProps = {
  onFormChange?: (hasChanges: boolean) => void;
};

export const hasFormChanges = (
  formApi: TFormApiWithDefaultValueState,
) => !formApi.state.isDefaultValue;

export const useForms = ({ onFormChange }: TUseFormsProps = {}) => {
  const onChange = useCallback(({ formApi }: TFormChangeListenerProps) => {
    onFormChange?.(hasFormChanges(formApi));
  }, [ onFormChange ]);
  const resetFormChanges = useCallback(() => {
    onFormChange?.(false);
  }, [ onFormChange ]);

  return {
    onChange,
    resetFormChanges,
  };
};
